// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"3ac56861","307":"9905bddb","378":"96466696","421":"c6b7d38a"}[chunkId] + ".css";
};